import { QuestionMarkCircleIcon } from "@heroicons/react/20/solid";
import clsx from "clsx";
import { useState } from "react";
import { IoMdEye, IoMdEyeOff } from "react-icons/io";

const FormInputPassword = ({
  label,
  name,
  value,
  handleChange,
  disabled = false,
  error,
}) => {
  const [show, setShow] = useState(false);
  return (
    <>
      <label
        htmlFor={name}
        className="block text-sm/6 font-medium text-gray-900"
      >
        {label}
      </label>
      <div className="mt-2 grid grid-cols-1">
        <input
          id={name}
          name={name}
          type={show ? "text" : "password"}
          onChange={handleChange}
          value={value ? value : ""}
          autoComplete="off"
          disabled={disabled}
          className={clsx(
            error
              ? "outline-red-600"
              : "outline-gray-300 focus:outline-amber-400",
            "col-start-1 row-start-1 block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 sm:text-sm/6"
          )}
        />
        <button
          type="button"
          className="cursor-pointer col-start-1 row-start-1 mr-3 self-center justify-self-end"
          onClick={() => setShow(!show)}
        >
          {show ? (
            <IoMdEye
              aria-hidden="true"
              className="size-5 text-gray-400 sm:size-5"
            />
          ) : (
            <IoMdEyeOff
              aria-hidden="true"
              className="size-5 text-gray-400 sm:size-5"
            />
          )}
        </button>
      </div>
      {error && <p className="mt-0 text-sm text-red-600">{error}</p>}
    </>
  );
};

export default FormInputPassword;
